import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SvgIconComponent } from '@mui/icons-material'

type PageHeaderProps = {
  title: string
  icon?: SvgIconComponent
  actions?: React.ReactNode
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, icon: Icon, actions }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 1.5,
      mb: 3,
      pb: 2,
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      {Icon && (
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            flexShrink: 0,
          }}
        >
          <Icon fontSize="small" />
        </Box>
      )}
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, letterSpacing: '-0.01em', lineHeight: 1.2 }}
      >
        {title}
      </Typography>
    </Box>
    {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
  </Box>
)

export default PageHeader
